import TextWithConditionalTooltip from "@/components/HOC/TooltipHOC/TextWithConditionalTooltip";

type TextCellWithConditionalTooltipProps = {
  text: string | null | undefined;
  maxLength?: number;
  truncate?: boolean;
};

const TextCellWithConditionalTooltip = ({
  text,
  maxLength = 20,
  truncate = true,
}: TextCellWithConditionalTooltipProps) => {
  const isEmpty = !text || text.trim() === "";

  if (isEmpty) {
    return <span style={{ color: "var(--text-default)" }}>-</span>;
  }

  return (
    <TextWithConditionalTooltip
      text={text}
      maxLength={maxLength}
      isMediaQueryRequired={false}
      truncate={truncate}
    />
  );
};

export default TextCellWithConditionalTooltip;
